/* =========================================================
   WooWoo Land - Custom Wishlist Engine (POC)
   Storage: localStorage + (optional) read-only dataset raw
   ========================================================= */

(function () {
  'use strict';

var BACKEND_BASE = 'https://ww-wishlist-backend.onrender.com';


  var LS_KEY = 'ww_wishlist_v1'; // localStorage key

  function log() {
    // keep logs consistent
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  function safeJsonParse(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  function uniq(arr) {
    var map = Object.create(null);
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var v = String(arr[i] || '').trim();
      if (!v) continue;
      if (!map[v]) {
        map[v] = 1;
        out.push(v);
      }
    }
    return out;
  }

  function readDatasetRaw() {
    // you already verified this exists on some pages:
    // document.documentElement.dataset.wwWishlistRaw
    var el = document.documentElement;
    if (!el || !el.dataset) return '';
    return el.dataset.wwWishlistRaw || '';
  }

  function parseRawList(raw) {
    // raw example: '["gid://shopify/Product/123","gid://shopify/Product/456"]'
    if (!raw) return [];
    var parsed = safeJsonParse(raw, []);
    if (!Array.isArray(parsed)) return [];
    return uniq(parsed);
  }

  // lock list_id within this page load to avoid "guest <-> customer" flipping
  var __WW_WL_LOCKED_LIST_ID = '';

  function getLocalKeyForCurrentIdentity() {
    // Use locked id if present (prevents remove from breaking)
    var listId = __WW_WL_LOCKED_LIST_ID;

    if (!listId) {
      try { listId = String(getActiveListId() || '').trim(); } catch (e) {}
    }

    if (!listId) return LS_KEY; // fallback
    return LS_KEY + '__' + listId; // ww_wishlist_v1__guest_xxx / __customer_xxx
  }

  function loadLocal() {
    var key = getLocalKeyForCurrentIdentity();

    // 1) Read identity bucket first
    var raw = '';
    try { raw = localStorage.getItem(key) || ''; } catch (e) {}
    var parsed = safeJsonParse(raw, []);
    if (Array.isArray(parsed) && parsed.length) return uniq(parsed);

    // 2) One-time migration: if bucket empty, copy from old shared key (LS_KEY)
    //    This prevents "suddenly empty wishlist" after we enable buckets.
    try {
      var oldRaw = localStorage.getItem(LS_KEY) || '';
      var oldParsed = safeJsonParse(oldRaw, []);
      if (Array.isArray(oldParsed) && oldParsed.length) {
        var migrated = uniq(oldParsed);
        // store into current bucket
        try { localStorage.setItem(key, JSON.stringify(migrated)); } catch (e) {}
        return migrated;
      }
    } catch (e) {}

    return [];
  }

  function saveLocal(list) {
    // Lock the list_id at first write (so add/remove stays in same bucket during this page load)
    if (!__WW_WL_LOCKED_LIST_ID) {
      try { __WW_WL_LOCKED_LIST_ID = String(getActiveListId() || '').trim(); } catch (e) {}
    }

    var cleaned = uniq(list || []);

    // 1) Write to identity bucket key (new system)
    var key = getLocalKeyForCurrentIdentity();
    try { localStorage.setItem(key, JSON.stringify(cleaned)); } catch (e) {}

    // 2) ALSO write to legacy key (old system) so your long wishlist page (2000 lines)
    //    that still reads `ww_wishlist_v1` will stay consistent after refresh.
    try { localStorage.setItem(LS_KEY, JSON.stringify(cleaned)); } catch (e) {}
  }




function saveActiveList(list) {
    // local-first: always save local immediately
    saveLocal(list);

    // fire-and-forget remote sync (never block UI)
    setTimeout(function () {
      try {
        var listId = getActiveListId(); // customer_<id> or guest_<guestId>
        if (!listId) return;
        remoteSave(listId, list || []).catch(function () {});
      } catch (e) {}
    }, 0);
  }


function remoteSave(listId, items) {
  try {
    return fetch(BACKEND_BASE + '/api/wishlist/save', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // ✅ 關鍵：避免 CORS「credentials include + allow-origin *」爆炸
      credentials: 'omit',
      body: JSON.stringify({
        list_id: String(listId || '').trim(),
        items: Array.isArray(items) ? items : []
      })
    })
      .then(function (r) { return r.json(); })
      .catch(function () { return { ok: false }; });
  } catch (e) {
    return Promise.resolve({ ok: false });
  }
}


function renderWishlistPage(items) {
  var root = document.getElementById('ww-wishlist-page');
  if (!root) return;

  var list = Array.isArray(items) ? items : [];

  if (!list.length) {
    root.innerHTML = '<div class="ww-wl-empty">No items yet.</div>';
    return;
  }

  var html = '<div class="ww-wl-grid">';

  for (var i = 0; i < list.length; i++) {
    var it = list[i] || {};
    var title = String(it.title || it.handle || 'Item');
    var url = String(it.url || '#');
    var img = String(it.image || '');
    var price = String(it.price || '');

    html += '<a class="ww-wl-card" href="' + url + '">';
    if (img) {
      html += '<div class="ww-wl-img"><img loading="lazy" src="' + img + '" alt=""></div>';
    }
    html += '<div class="ww-wl-meta">';
    html += '<div class="ww-wl-title">' + title + '</div>';
    if (price) html += '<div class="ww-wl-price">' + price + '</div>';
    html += '</div></a>';
  }

  html += '</div>';
  root.innerHTML = html;
}



function setRemoteWishlist(list) {
  // Update injected remote list in-memory so UI reflects changes immediately.
  // (No API write yet - Step 20 will do the server sync.)
  try {
    window.__WW_REMOTE_WISHLIST__ = uniq(list || []);
  } catch (e) {}
}

// Fire-and-forget remote sync (never block UI)
function fireAndForgetRemoteSync(list) {
  try {
    var clean = uniq(list || []);
    var listId = getActiveListId();
    var items = Array.isArray(clean) ? clean : [];

    setTimeout(function () {
      try { remoteSave(listId, items); } catch (e) {}
    }, 0);
  } catch (e) {}
}

// Backward compat: older code may still call api_sync_remote(...)
function api_sync_remote(list) {
  try {
    if (typeof fireAndForgetRemoteSync === 'function') fireAndForgetRemoteSync(list);
  } catch (e) {}
  return Promise.resolve({ ok: true, queued: true });
}






function getActiveList() {
  // POC rule (updated for stability):
  // - Always use localStorage as the writable source of truth (guest OR logged-in)
  // - If remote list exists and has items, merge it (read-only) but never replace local
  //   (because remote is not persisted yet in your current stage)
  try {
    var local = loadLocal();

    if (window.__WW_CUSTOMER_LOGGED_IN__) {
      var remote = window.__WW_REMOTE_WISHLIST__;
      if (Array.isArray(remote) && remote.length) {
        // merge: keep local-first ordering + add missing remote items
        var merged = local.slice();
        for (var i = 0; i < remote.length; i++) {
          var gid = String(remote[i] || '').trim();
          if (!gid) continue;
          if (merged.indexOf(gid) === -1) merged.push(gid);
        }
        return uniq(merged);
      }
    }

    return uniq(local);
  } catch (e) {}

  return loadLocal();
}

function getActiveListId() {
  // ✅ LOGGED-IN: always use customer_<id>
  try {
    var cid =
      (typeof window.WW_CUSTOMER_ID !== 'undefined' && window.WW_CUSTOMER_ID) ? window.WW_CUSTOMER_ID :
      (typeof window.__WW_CUSTOMER_ID !== 'undefined' && window.__WW_CUSTOMER_ID) ? window.__WW_CUSTOMER_ID :
      (typeof window.wwCustomerId !== 'undefined' && window.wwCustomerId) ? window.wwCustomerId :
      null;

    if (cid !== null && cid !== '' && cid !== 'null' && cid !== 'undefined') {
      return 'customer_' + String(cid);
    }
  } catch (e) {}

  // ✅ GUEST: stable per-browser guest id (NOT shared "guest")
  return 'guest_' + String(getGuestId());
}



// 方便你 console 即刻驗證（可留可唔留）
window.WW_DEBUG_getActiveListId = getActiveListId;



function getGuestId() {
    var KEY = 'ww_wishlist_guest_id_v1';
    try {
      var v = localStorage.getItem(KEY);
      if (v) return v;
      v = 'g' + Date.now() + '_' + Math.random().toString(16).slice(2);
      localStorage.setItem(KEY, v);
      return v;
    } catch (e) {
      return 'g' + Date.now() + '_' + Math.random().toString(16).slice(2);
    }
  }




  function setPressedStateForButtons(activeList) {
    // Try to find your heart button in a "safe but flexible" way.
    // Later we will add a dedicated data-attr; for now this covers common cases.
    var selector = [
      '[data-ww-wishlist-toggle]',
      '.ww-wishlist-toggle',
      'button[name="wishlist"]',
      'button[data-wishlist]',
      'button[aria-label*="wishlist"]',
      'button[aria-label*="Wishlist"]'
    ].join(',');

    var buttons = document.querySelectorAll(selector);
    if (!buttons || !buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var gid = btn.getAttribute('data-ww-wishlist-gid') || btn.getAttribute('data-product-gid') || '';
      if (!gid) {
        // if no gid on button, we can't know which product it represents yet
        // still keep aria-pressed consistent (false)
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('is-wishlisted');
        continue;
      }

      var isOn = activeList.indexOf(gid) !== -1;
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      if (isOn) btn.classList.add('is-wishlisted');
      else btn.classList.remove('is-wishlisted');
    }
  }

function syncWishlistButtonUI(btn, isOn) {
  if (!btn) return;

  // aria state
  btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');

  // class state (optional, but useful)
  if (isOn) btn.classList.add('is-on');
  else btn.classList.remove('is-on');

  // icon spans (works even without CSS)
  var offEl = btn.querySelector('.ww-wl-icon__off');
  var onEl  = btn.querySelector('.ww-wl-icon__on');

  if (offEl) offEl.style.display = isOn ? 'none' : '';
  if (onEl)  onEl.style.display  = isOn ? '' : 'none';
}



function api_getList() {
  // local-first: ALWAYS prefer localStorage
  var local = loadLocal();
  if (Array.isArray(local) && local.length) return local;

  // optional fallback: dataset raw (read-only)
  var raw = readDatasetRaw();
  var ds = parseRawList(raw);
  if (Array.isArray(ds) && ds.length) return ds;

  return [];
}


  function api_count() {
    return api_getList().length;
  }

  function api_has(gid) {
    gid = String(gid || '').trim();
    if (!gid) return false;
    return api_getList().indexOf(gid) !== -1;
  }

function api_add(gid) {
  gid = String(gid || '').trim();
  if (!gid) return false;

  var list = getActiveList();
  if (list.indexOf(gid) === -1) {
    list.push(gid);
    saveActiveList(list);
    setPressedStateForButtons(list);
    log('[WW_WISHLIST] add:', gid, 'count:', list.length);
    
    // Update header count after adding
    try {
      if (typeof window.WW_WL_updateHeaderCount === 'function') {
        window.WW_WL_updateHeaderCount();
      }
    } catch (e) {}
    
    // Show notification bar
    try {
      if (typeof window.showWishlistNotification === 'function') {
        window.showWishlistNotification();
      }
    } catch (e) {}
  }
  return true;
}




function api_remove(gid) {
  gid = String(gid || '').trim();
  if (!gid) return false;

  var list = getActiveList();
  var idx = list.indexOf(gid);

  if (idx !== -1) {
    list.splice(idx, 1);
    saveActiveList(list);
    setPressedStateForButtons(list);
    log('[WW_WISHLIST] remove:', gid, 'count:', list.length);
    
    // Update header count after removal
    try {
      if (typeof window.WW_WL_updateHeaderCount === 'function') {
        window.WW_WL_updateHeaderCount();
      }
    } catch (e) {}
  }
  return true;
}



function api_toggle(gid) {
  gid = String(gid || '').trim();
  if (!gid) return false;

  var isOn = false;

  if (api_has(gid)) {
    api_remove(gid);
    isOn = false;
  } else {
    api_add(gid);
    isOn = true;
  }

  // ✅ sync UI for all buttons with this gid (fixes "btn is not defined")
  var safeGid = gid.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  var btns = document.querySelectorAll('[data-ww-wishlist-gid="' + safeGid + '"]');
  for (var i = 0; i < btns.length; i++) {
    syncWishlistButtonUI(btns[i], isOn);
  }

// keep aria/class consistent too
setPressedStateForButtons(api_getList());

return true;

}


// ---------- Helper: resolve gid from current product page ----------
function ww_getCurrentProductHandle() {
  // /products/<handle>[/...]
  var p = String(location.pathname || '');
  var m = p.match(/^\/products\/([^\/\?]+)\b/);
  return m ? decodeURIComponent(m[1]) : '';
}

function ww_fetchProductJsByHandle(handle) {
  // locale root not critical here; Shopify will resolve /products/ correctly
  return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); });
}

function ww_gidFromNumericProductId(id) {
  return 'gid://shopify/Product/' + String(id);
}

function ww_toggleFromCurrentProduct(el) {
  var handle = ww_getCurrentProductHandle();
  if (!handle) {
    log('[WW_WISHLIST] missing handle (not on product page)');
    return;
  }

  ww_fetchProductJsByHandle(handle).then(function (p) {
    if (!p || !p.id) {
      log('[WW_WISHLIST] product.js missing id');
      return;
    }

    var gid = ww_gidFromNumericProductId(p.id);

    // ✅ write back gid onto the clicked button for next time
    try { if (el && el.setAttribute) el.setAttribute('data-ww-wishlist-gid', gid); } catch (e) {}

    // now toggle normally
    api_toggle(gid);
  }).catch(function (err) {
    log('[WW_WISHLIST] resolve gid failed', err);
  });
}



  function extractHandleFromHref(href) {
    try {
      if (!href) return '';
      // handle patterns:
      // /products/abc
      // https://xxx.com/products/abc?variant=...
      var m = String(href).match(/\/products\/([^\/\?\#]+)/i);
      return m && m[1] ? String(m[1]).trim() : '';
    } catch (e) {}
    return '';
  }

function ww_toggleFromWishlistCard(el) {
  // Find a product link near the heart button
  var a = null;

  try {
    // closest card container first, then search inside it
    var card = el.closest && el.closest('.ww-wl-card, .ww-wl-item, [data-ww-wishlist-card], li, article, div');
    if (card) a = card.querySelector('a[href*="/products/"]');
  } catch (e1) {}

  try {
    // fallback: search upward then sideways
    if (!a) a = el.closest && el.closest('a[href*="/products/"]');
    if (!a) a = (el.parentElement && el.parentElement.querySelector) ? el.parentElement.querySelector('a[href*="/products/"]') : null;
  } catch (e2) {}

  var href = a ? (a.getAttribute('href') || '') : '';
  var handle = extractHandleFromHref(href);

  if (!handle) return false; // can't resolve -> let fake handler run

  // Async resolve: /products/<handle>.js -> product.id -> gid -> toggle
  try {
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'omit' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (p) {
        var pid = p && p.id ? String(p.id) : '';
        if (!pid) return;
        var gid = 'gid://shopify/Product/' + pid;
        api_toggle(gid);
      })
      .catch(function () {});
  } catch (e3) {}

  return true;
}


  function bindClicks() {
    document.addEventListener('click', function (e) {
      var target = e.target;

      // climb up to clickable element
      var el = target;
      while (el && el !== document.documentElement) {
if (
  el.matches &&
  (
    el.matches('[data-ww-wishlist-toggle]') ||
    el.matches('.ww-wishlist-toggle') ||
    el.matches('.ww-wl-heart') ||              // wishlist page heart
    el.matches('.ww-grid-heart') ||            // ← ADD THIS LINE
    el.matches('.ww-pdp-heart') ||

    el.matches('button[name="wishlist"]') ||

            el.matches('button[data-wishlist]') ||
            (el.matches('button') && (
              (el.getAttribute('aria-label') || '').toLowerCase().indexOf('wishlist') !== -1
            ))
          )
        ) {
          break;
        }
        el = el.parentElement;
      }

      if (!el || el === document.documentElement) return;

      // Try gid from attributes
      var gid =
        el.getAttribute('data-ww-wishlist-gid') ||
        el.getAttribute('data-product-gid') ||
        el.getAttribute('data-gid') ||
        '';

      // Try closest parent holder with gid
      if (!gid) {
        try {
          var holder = el.closest && el.closest('[data-ww-wishlist-gid],[data-product-gid],[data-gid]');
          if (holder) {
            gid =
              holder.getAttribute('data-ww-wishlist-gid') ||
              holder.getAttribute('data-product-gid') ||
              holder.getAttribute('data-gid') ||
              '';
            try { if (gid) el.setAttribute('data-ww-wishlist-gid', gid); } catch (e2) {}
          }
        } catch (e3) {}
      }

// Case 1: we have gid -> real toggle
if (gid) {
  e.preventDefault();
  try { e.stopPropagation(); } catch (e4) {}
  try { e.stopImmediatePropagation(); } catch (e5) {}
  
  // Check if item is currently in wishlist
  var wasInList = api_has(gid);
  
  // Toggle it
  api_toggle(gid);
  
  // If it was in the list and we just removed it, remove card from DOM (wishlist page)
  if (wasInList) {
    try {
      var cardEl = el.closest('.ww-wl-card');
      if (cardEl && cardEl.remove) {
        cardEl.remove();
        
        // Update header count
        if (typeof window.WW_WL_updateHeaderCount === 'function') {
          window.WW_WL_updateHeaderCount();
        }
      }
    } catch (e6) {}
  }
  
  return;
}


      // Case 2: wishlist page heart but no gid -> try resolve from product link
      if (el.matches && el.matches('.ww-wl-heart')) {
        var started = ww_toggleFromWishlistCard(el);
        if (started) {
          // We are handling it (async). Block fake removal.
          e.preventDefault();
          try { e.stopPropagation(); } catch (e6) {}
          try { e.stopImmediatePropagation(); } catch (e7) {}
          return;
        }
        // if not started, do nothing -> allow fake handler
        return;
      }

      // Otherwise: no gid and not WL heart -> keep original behavior (do nothing)
      return;

    }, true);
  }






// expose API
window.WW_WISHLIST = {
  version: '0.2.0',
  ready: true,

  // read
  getList: api_getList,
  count: api_count,
  has: api_has,

  // write (POC uses localStorage only)
  add: api_add,
  remove: api_remove,
  toggle: api_toggle,
  
  // bulk write (for WL page)
  setList: function(list) {
    saveActiveList(list || []);
    setPressedStateForButtons(list || []);
    
    // Update header count
    try {
      if (typeof window.WW_WL_updateHeaderCount === 'function') {
        window.WW_WL_updateHeaderCount();
      }
    } catch (e) {}
  }
};


  // boot
  log('[WW_WISHLIST] asset loaded v' + window.WW_WISHLIST.version);
log('[WW_WISHLIST] localStorage list:', loadLocal());
  log('[WW_WISHLIST] parsed list:', api_getList());

function applyIconState() {
var btns = document.querySelectorAll('.ww-wl-icon[data-ww-wishlist-gid], .ww-grid-heart[data-ww-wishlist-gid], .ww-pdp-heart[data-ww-wishlist-gid]');


  if (!btns.length) return;

  for (var i = 0; i < btns.length; i++) {
    var b = btns[i];
    var gid = b.getAttribute('data-ww-wishlist-gid') || '';
    var on = api_has(gid);

    if (on) {
      b.classList.add('is-on');
      b.setAttribute('aria-pressed', 'true');
    } else {
      b.classList.remove('is-on');
      b.setAttribute('aria-pressed', 'false');
    }
  }
}


setPressedStateForButtons(api_getList());
applyIconState();

// Wishlist page: render immediately from local-first list (no blocking)
try {
  renderWishlistPage(getActiveList());
} catch (e) {}


  bindClicks();

  // =========================================================
  // LOGOUT HANDLER: Clear guest wishlist after logout
  // =========================================================
  (function () {
    try {
      var WAS_LOGGED_IN_KEY = 'ww_was_logged_in';
      var wasLoggedIn = localStorage.getItem(WAS_LOGGED_IN_KEY) === '1';
      var isLoggedIn = false;

      // Check current login state
      try {
        var cid =
          (typeof window.WW_CUSTOMER_ID !== 'undefined' && window.WW_CUSTOMER_ID) ? window.WW_CUSTOMER_ID :
          (typeof window.__WW_CUSTOMER_ID !== 'undefined' && window.__WW_CUSTOMER_ID) ? window.__WW_CUSTOMER_ID :
          (typeof window.wwCustomerId !== 'undefined' && window.wwCustomerId) ? window.wwCustomerId :
          null;

        if (cid !== null && cid !== '' && cid !== 'null' && cid !== 'undefined' && cid !== 0 && cid !== '0') {
          isLoggedIn = true;
        }
      } catch (e) {}

      // LOGOUT DETECTED
      if (wasLoggedIn && !isLoggedIn) {
        log('[WW_WISHLIST] Logout detected - clearing guest wishlist');

        // Clear all wishlist storage
        try {
          localStorage.setItem(LS_KEY, JSON.stringify([]));
          
          // Clear all customer/guest buckets AND merge flags
          var keys = Object.keys(localStorage);
          for (var i = 0; i < keys.length; i++) {
            // Clear wishlist buckets
            if (keys[i].indexOf('ww_wishlist_v1__') === 0) {
              localStorage.removeItem(keys[i]);
            }
            // Clear merge flags so next login can merge again
            if (keys[i].indexOf('ww_wl_merged_') === 0) {
              localStorage.removeItem(keys[i]);
              log('[WW_WISHLIST] Cleared merge flag: ' + keys[i]);
            }
          }
          
          log('[WW_WISHLIST] Guest wishlist cleared');
        } catch (e) {}

        // Clear login flag
        localStorage.removeItem(WAS_LOGGED_IN_KEY);

        // Refresh UI
        try {
          setPressedStateForButtons([]);
          applyIconState();
        } catch (e) {}
      }

      // Save current login state
      if (isLoggedIn) {
        localStorage.setItem(WAS_LOGGED_IN_KEY, '1');
      } else {
        localStorage.removeItem(WAS_LOGGED_IN_KEY);
      }

    } catch (e) {
      log('[WW_WISHLIST] Logout handler error:', e);
    }
  })();

})();






